import Debug from '@substrate-system/debug'
import { HamburgerTwo } from '@substrate-system/hamburger-two'
import '@substrate-system/hamburger-two/css'

const debug = Debug(DEV)

const IMAGE_URL = '/_assets/city_rug.jpg'
const TIMEOUT_MS = 8000

function revealWhenReady (
    imageUrl = IMAGE_URL,
    timeoutMs = TIMEOUT_MS
):void {
    let revealed = false
    let timerId:ReturnType<typeof setTimeout>|null = null

    timerId = setTimeout(reveal, timeoutMs)

    const img = new Image()
    img.addEventListener('load', reveal)
    img.addEventListener('error', reveal)
    img.src = imageUrl

    // Cached images may already be complete before events fire.
    if (img.complete) reveal()

    function reveal ():void {
        if (revealed) return
        revealed = true
        if (timerId !== null) clearTimeout(timerId)
        document.documentElement.classList.remove('hero-loading')
        debug('hero revealed')
    }
}

revealWhenReady()

const mobileMenu = document.querySelector<HTMLElement>('.mobile-nav-menu')
const hamburger = document.querySelector<HamburgerTwo>(HamburgerTwo.TAG)

hamburger?.addEventListener(HamburgerTwo.event('open'), () => {
    mobileMenu?.classList.add('open')
})

hamburger?.addEventListener(HamburgerTwo.event('close'), () => {
    mobileMenu?.classList.remove('open')
})

mobileMenu?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
        mobileMenu.classList.remove('open')

        if (hamburger) hamburger.isOpen = false
    })
})

// Progressive enhancement for the email signup form. Without JS the form
// performs a normal POST to /api/signup and the server redirects to
// /thanks/. With JS we send the same request via fetch and swap an inline
// thanks message in place, falling back to native submission on failure.
const signupForms = document
    .querySelectorAll<HTMLFormElement>('form.signup-form')

signupForms.forEach((signupForm) => {
    signupForm.addEventListener('submit', (event) => {
        event.preventDefault()
        sendSignup(signupForm).catch(() => {
            // error already handled inside sendSignup
        })
    })
})

async function sendSignup (form:HTMLFormElement):Promise<void> {
    try {
        const response = await fetch(form.action, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
        })

        if (!response.ok) {
            // Server rejected the input or errored: fall back to the native
            // submission, which produces the no-JS redirect experience.
            form.submit()
            return
        }

        const input = form.querySelector<HTMLInputElement>(
            'input[type="email"]'
        )
        const button = form.querySelector<HTMLButtonElement>(
            'button[type="submit"]'
        )
        if (input) input.disabled = true
        if (button) {
            button.disabled = true
            button.setAttribute('aria-disabled', 'true')
        }

        const thanks = form.parentElement?.querySelector('.signup-thanks')
        if (thanks) {
            thanks.textContent = 'Thanks! We will be in touch.'
            thanks.classList.add('visible')
        }
    } catch {
        // Network/fetch failure: fall back to native submission (AC4.3).
        form.submit()
    }
}
